/*
 * fn: getImpactLink
 *
 * Gets impact links for brands
 *
 */
import { type BrandType } from '@/defs/brand'

type ImpactBrandType = Extract<BrandType, 'scg' | 'tcgplayer'>

type Props = {
  brand: ImpactBrandType
  subId1: string
  u: string
}

const CONFIG: Record<ImpactBrandType, (props: Props) => string> = {
  scg: ({ subId1, u }) => {
    const params = new URLSearchParams({ subId1, u })
    return `https://goto.starcitygames.com/c/4913290/3052179/37198?${params.toString()}`
  },
  tcgplayer: ({ subId1, u }) => {
    const params = new URLSearchParams({ partnerpropertyid: '5237567', subId1, u })
    return `https://partner.tcgplayer.com/c/4913290/1830156/21018?${params.toString()}`
  },
}

export const getImpactLink = (props: Props) => CONFIG[props.brand](props)
